import { useContext } from "react";
import { Button, Typography } from "@material-ui/core";
import { AuthContext } from "../../../../../../../context/context";
import { InputFile } from "../fields";
import useStyles from "./styles";
import { AltaContext } from "../../../../../context";
import { ResultTable } from "../resultsTable";
export const UploadExcel = ({ returntoMain }) => {
  const classes = useStyles();
  const { setTimer } = useContext(AuthContext);
  const { file, setFile, savedPersons } = useContext(AltaContext);

  const handleChange = (files) => {
    setTimer(0);
    setFile(files[0]);
  };

  if (!!savedPersons) return <ResultTable />;
  return (
    <div>
      <Typography className={classes.title} variant="h6">
        Agregar archivo de asegurados
      </Typography>
      <InputFile
        required
        label="Archivo de asegurados"
        onChange={handleChange}
        name={file?.name}
      />
      <Typography className={classes.caption} variant="caption">
        Recuerda que solo se permiten documentos excel (.xlsx)
      </Typography>
      <Button
        className={classes.backButton}
        variant="text"
        onClick={() => {
          setTimer(0);
          returntoMain();
        }}
      >
        Regresar
      </Button>
    </div>
  );
};
